import { lazy } from 'react';
const Editor = lazy(() => import('../../views/Editor/index'));
const EditorRoutes = [
    {
        path: '/settings/editor',
        element: <Editor />
    }
];

export default EditorRoutes;
